export default {
    data(){
        return{
    en: {
      /* ===================== NAV_NAME ======================*/

        nav_name: "Rosy Nebula",

      /* ===================== HOME ======================*/

      nav_home_title: "Home",

        /* ===================== NAV INDUSTRY AREA ======================*/
      nav_industry_area_title: "Industry Area",
      nav_industry_area: [
        {
          title: "Film And Television",
          description: "Descriptions",
          link: { path: '/industryarea', hash: '#film_television' }
        },
        {
          title: "Culture Tour",
          description: "Descriptions",
          link: { path: '/industryarea', hash: '#culture_tour' }
        },
        {
          title: "Digital Assets",
          description: "Descriptions",
          link: { path: '/industryarea', hash: '#digital_assets' }
        },
        {
          title: "AIGC",
          description: "Descriptions",
          link: { path: '/industryarea', hash: '#aigc' }
        }
      ],

      /* ===================== PLAN AND CASES ======================*/

      plan_and_cases_title: "Plan And Cases",

      /* ===================== News ======================*/

      news_title: "News",

      /* ===================== News ======================*/

      about_us_title: "About Us",

      /* ===================== News ======================*/

      // contact_us_title: "Contact Us",
      
    }
}
}
  };
  